<template>
    <Message
        v-if="jackpotMessage"
        v-bind:key="key"
        v-gtm:label="'Msg'"
        v-gtm:page="gtmPage"
        v-gtm:type="gtmType"
        v-gtm:@view
        v-bind:show="true"
        rounded
        status="info"
        position="bottom"
        v-bind:message="jackpotMessage"
        animationName="slideUp"
        class="jackpotMessage"
    >
        <VButton
            v-if="isShowAddNowButton"
            v-gtm:label="'Btn'"
            v-gtm:page="gtmPage"
            v-gtm:type="'BetSlipNextPool'"
            v-gtm:@click
            outline
            outlineColor="primary"
            hoverColor="primary"
            padding="4px 8px"
            class="jackpotMessageButton"
            v-on:click="fillUpToMinQualifyingAmount()"
        >
            {{ i18n.t('bet_slip_notice_jackpot_qualification_cta') }}
        </VButton>
    </Message>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import Message from '@/components/betSlip/Message.vue';
    import useJackpotMessageDisplay from '@/components/betSlip/useJackpotMessageDisplay';
    import VButton from '@/components/common/button/VButton.vue';
    import { i18n } from '@/core/lib/i18n';
    import { SiteStyle } from '@/interface/enum';
    import { useToggleStore } from '@/store/toggleStore';

    const { jackpotMessage, isShowAddNowButton, isAllQualified, fillUpToMinQualifyingAmount } = useJackpotMessageDisplay();
    const { isSwitchEFootballToSimulationSportsZoneEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const gtmType = computed(() => (isAllQualified.value ? 'BetSlipQualified' : 'BetSlipNextPool'));
    const gtmPage = computed(() => (isSwitchEFootballToSimulationSportsZoneEnabled.value ? 'K_JackPot' : 'K_Efootball_JP'));

    const key = computed(() => isAllQualified.value.toString());
</script>

<style lang="scss">
@import "@/components/betSlip/JackpotNextPoolMessage";
</style>
